export default [{"id":"1","startTime":0,"endTime":3888,"text":"<b>Im nächsten Arbeitsschritt wird die Rückwand montiert.</b>"}];